import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import IndexHomepage from './pages';
import ArenaSection from './components/section/arena';
import LeaderboardPage from './pages/leaderboard';
import { WalletContextProvider } from './components/WalletContextProvider';
import MusicPlayer from './components/MusicPlayer';

const App: React.FC = () => {
  return (
    <WalletContextProvider>
      <Router>
        <div className="min-h-screen bg-gaming-dark text-white">
          <main>
            <Routes>
              <Route path="/" element={<IndexHomepage />} />
              <Route path="/arena" element={<ArenaSection />} />
              <Route path="/leaderboard" element={<LeaderboardPage />} />
            </Routes>
          </main>
          <MusicPlayer />
        </div>
      </Router>
    </WalletContextProvider>
  );
};

export default App;
